import { Link } from "react-router-dom"
import { APP_NAME, MARKETPLACE_ENABLED, BILLING_ENABLED } from "@/lib/appConfig"

export default function PublicFooter() {
    const year = new Date().getFullYear()
    return (
        <footer className="border-t border-border/60 bg-muted/20">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12">
                <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-10">
                    {/* Brand */}
                    <div className="col-span-2 md:col-span-1">
                        <div className="flex items-center gap-2 mb-3">
                            <img src="/app-icon.png" className="h-8 w-8 object-contain" alt={APP_NAME} />
                            <span className="font-bold text-base tracking-tight">{APP_NAME.toUpperCase()}</span>
                        </div>
                        <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
                            Modern property management for independent European landlords.
                        </p>
                    </div>

                    {/* Product */}
                    <div className="pl-0 md:pl-4">
                        <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-3">Product</p>
                        <ul className="space-y-2 text-sm text-muted-foreground">
                            <li><a href="/#features" className="hover:text-foreground transition-colors">Features</a></li>
                            {BILLING_ENABLED && <li><a href="/#pricing" className="hover:text-foreground transition-colors">Pricing</a></li>}
                            <li><a href="/#how-it-works" className="hover:text-foreground transition-colors">How It Works</a></li>
                            {MARKETPLACE_ENABLED && <li><Link to="/listings" className="hover:text-foreground transition-colors">Listings</Link></li>}
                            <li><Link to="/blog" className="hover:text-foreground transition-colors">Blog</Link></li>
                        </ul>
                    </div>

                    {/* Free Tools */}
                    <div className="pl-0 md:pl-4">
                        <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-3">Free Tools</p>
                        <ul className="space-y-2 text-sm text-muted-foreground">
                            <li><Link to="/tools/rental-yield-calculator" className="hover:text-foreground transition-colors">Rental Yield</Link></li>
                            <li><Link to="/tools/cash-flow-calculator" className="hover:text-foreground transition-colors">Cash Flow</Link></li>
                            <li><Link to="/tools/rent-increase-calculator" className="hover:text-foreground transition-colors">Rent Increase</Link></li>
                            <li><Link to="/tools" className="font-medium text-primary hover:opacity-80 transition-opacity mt-1 block">View all tools →</Link></li>
                        </ul>
                    </div>

                    {/* Account */}
                    <div className="pl-0 md:pl-4">
                        <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-3">Account</p>
                        <ul className="space-y-2 text-sm text-muted-foreground">
                            <li><Link to="/register" className="hover:text-foreground transition-colors">Sign Up Free</Link></li>
                            <li><Link to="/login" className="hover:text-foreground transition-colors">Sign In</Link></li>
                            {BILLING_ENABLED && <li><Link to="/pricing" className="hover:text-foreground transition-colors">Plans</Link></li>}
                        </ul>
                    </div>

                    {/* Legal */}
                    <div className="pl-0 md:pl-4">
                        <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-3">Legal</p>
                        <ul className="space-y-2 text-sm text-muted-foreground">
                            <li><Link to="/privacy-policy" className="hover:text-foreground transition-colors">Privacy Policy</Link></li>
                            <li><Link to="/terms-of-service" className="hover:text-foreground transition-colors">Terms of Service</Link></li>
                            <li><Link to="/privacy-policy#cookies" className="hover:text-foreground transition-colors">Cookie Policy</Link></li>
                            <li><Link to="/roadmap" className="hover:text-foreground transition-colors">Roadmap</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="pt-6 border-t border-border/60 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
                    <p>© {year} {APP_NAME}. All rights reserved.</p>
                    <p>Built for European independent landlords.</p>
                </div>
            </div>
        </footer>
    )
}
